<template>
    <div class="gift-main-div">
        <div class="summary-div">
            <p>Summary</p>
        </div>
        <div class="rec-name-div">
            <span>Recipient Name</span>
            <p>{{ name }}</p>
        </div>
        <div class="email-section">
            <span>Recipient Email</span>
            <p class="hidden lg:block">{{ email }}</p>
            <p v-if="isTextTruncated"
                v-tooltip.top="{
                value: email,
                pt: {
                    text: 'bg-zinc-900 text-white text-sm font-medium px-2 py-1 rounded max-w-64 whitespace-normal break-words border border-gray-700 ml-6',
                },
            }" class="block lg:hidden">{{ truncateText(email, 30) }}</p>
            <p v-else class="block lg:hidden">{{ email }}</p>
        </div>
        <div class="dashed-bottom">
            <span>Certificate value</span>
            <p>{{ formatCurrency(amount) }}</p>
        </div>
        <div class="card-div">
            <div class="card-wrapper">
                <credit-card-mockup :email="email" :creditAmount="amount" :cardNumber="code" />
            </div>
            <div class="message-div" v-if="isEmailSent || isCopyCode">
                <PhCheckCircle :size="20" class="text-green-500" weight="fill" />
                <p v-if="isEmailSent" class="block lg:hidden">Email sent to {{ truncateText(email, 15) }}</p>
                <p v-if="isEmailSent" class="hidden lg:block">Email sent to {{ email }}</p>
                <p v-else-if="isCopyCode">Code copied to clipboard!</p>
            </div>
            <div class="message-div" v-else></div>
            <footer-gift-cert-purchased
                @handle-email-click="handleEmailClick"
                :is-email-sent="isEmailSent"
                @handle-copy-code="handleCopyCode"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import CreditCardMockup from '~/components/modals/person/CreditCardMockup.vue';

import FooterGiftCertPurchased from './FooterGiftCertPurchased.vue';

import { useSubscribeStore } from '@/stores/components/modals/subscription-modal';

const { truncateText } = useUtils();

const store = useSubscribeStore();
const { formatCurrency } = useUtils();

const isEmailSent = ref(false);
const isCopyCode = ref(false);
const name = computed(() => store.giftCertName || '-');
const code = computed(() => store.giftCertCode || '-');
const email = computed(() => store.giftCertEmail || '-');
const amount = computed(() => store.giftCertAmount || 0);

const handleEmailClick = () => {
    isEmailSent.value = true;
};
const handleCopyCode = () => {
    isCopyCode.value = true;
};

// Check if text needs to be truncated
const isTextTruncated = computed(() => {
    return email.value.length > 30;
});
</script>
<style lang="scss" scoped>
.gift-main-div {
    @apply flex flex-col items-center self-stretch w-full;
}
.summary-div {
    @apply flex pb-6 items-center gap-1 self-stretch;

    p {
        @apply text-gray-900 font-inter text-xl font-semibold leading-8;
    }
}
.rec-name-div {
    @apply flex justify-between items-center self-stretch py-3 border-t border-b border-dashed border-zinc-300;

    span {
        @apply text-zinc-800 font-inter text-base font-normal leading-8;
    }

    p {
        @apply text-zinc-950 text-right font-inter text-base font-medium leading-8;
    }
}
.dashed-bottom {
    @apply flex justify-between items-center self-stretch py-3 border-b border-dashed border-zinc-300;

    span {
        @apply text-zinc-800 font-inter text-base font-normal leading-8;
    }

    p {
        @apply text-zinc-950 text-right font-inter text-base font-medium leading-8;
    }
}
.email-section {
    @apply flex flex-col lg:flex-row justify-between items-start lg:items-center self-stretch py-3 border-b border-dashed border-zinc-300;

    span {
        @apply text-zinc-800 font-inter text-base font-normal leading-8;
    }

    p {
        @apply text-zinc-950 text-right font-inter text-base font-medium leading-8;
    }
}
.card-div {
    @apply flex flex-col items-center self-stretch pt-6 gap-6;
}
.card-wrapper {
    @apply flex flex-col justify-center items-center self-stretch px-0 lg:px-6 pt-6;
}
.message-div {
    @apply flex py-1 justify-center items-center gap-2 self-stretch;

    p {
        @apply text-zinc-500 font-inter text-sm font-medium leading-5;
    }
}
</style>
